import { useInfiniteQuery } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { evalKeys } from '@/lib/queryKeys'
import type { EvalTestCasesQueryParams } from '../types'
import { fetchEvalTestCases } from '../api'

export function useEvalTestCasesQuery(params: EvalTestCasesQueryParams = {}) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useInfiniteQuery({
    queryKey: evalKeys.testCases(organization?.id, params),
    queryFn: async ({ pageParam }) => {
      const token = await getToken()
      if (!token) throw new Error('No authentication token available')
      return fetchEvalTestCases(token, params, pageParam as string | undefined)
    },
    getNextPageParam: (lastPage) =>
      lastPage.pagination.next_cursor ?? undefined,
    initialPageParam: undefined as string | undefined,
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
